import React, { useEffect, useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, Alert, TextField,
} from "@mui/material";
import axios from "../../../config/axiosConfig";

// Reemplaza editar_monto.php + guarda_monto_parcial.php: el legacy mostraba además un
// "comprobante" completo de solo lectura (fecha, dirigido a, banco, literal en letras,
// etc.) antes del formulario — se recorta a lo esencial (el ítem ya se ve en la fila
// de la tabla que abrió este diálogo) para no duplicar esa información acá.
const EditarMontoParcialDialog = ({ open, onClose, proyectoId, tipo, item, onGuardado }) => {
  const [monto, setMonto] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (open && item) {
      setMonto(item.monto_parcial || "0");
      setError("");
    }
  }, [open, item]);

  const handleGuardar = async () => {
    setSaving(true);
    setError("");
    try {
      await axios.patch(`/api/proyectos/${proyectoId}/monto-parcial/${tipo}/${item.id}`, {
        monto_parcial: Number(monto),
      });
      onGuardado();
    } catch (e) {
      setError(e?.response?.data?.message || "Error al guardar el monto parcial.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 800 }}>Monto Parcial — {tipo === "cod_egreso" ? "Egreso" : "Orden de Compra"} #{item?.id}</DialogTitle>
      <DialogContent dividers>
        {error && <Alert severity="error" sx={{ mb: 1.5 }}>{error}</Alert>}
        <Stack spacing={1.5}>
          <TextField
            size="small" type="number" label="Monto Parcial en Bs." autoFocus
            value={monto} onChange={(e) => setMonto(e.target.value)}
            inputProps={{ min: 0, step: "0.01" }}
            helperText="Dejar en 0 para usar el monto total del comprobante."
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancelar</Button>
        <Button variant="contained" onClick={handleGuardar} disabled={saving || monto === ""}>
          {saving ? "Guardando..." : "Guardar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditarMontoParcialDialog;
